import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';

import { TooltipButtonComponent } from '../components/tooltip-button/tooltip-button.component';
import { TooltipDialogComponent } from '../components/tooltip-dialog/tooltip-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    MatTooltipModule,
    MatDialogModule,
    OverlayModule,
    TranslateModule,
    TooltipButtonComponent,
    TooltipDialogComponent,
  ],
  exports: [TooltipButtonComponent, TooltipDialogComponent],
})
export class DirectivesModule {}
